import React, {ReactElement, useState} from "react";
import {FloatButton} from "antd";
import {observer} from "mobx-react-lite";
import {
  CompassOutlined,
  MinusOutlined,
  PlusOutlined,
  SendOutlined,
} from "@ant-design/icons";
import {useStore} from "@ui/stores";
import AimIcon from "@ui/icons/common/Aim";
import OSMIcon from "@ui/icons/menu/float/OSM"
import S57Icon from "@ui/icons/menu/float/S57"

const Buttons = (): ReactElement => {
	const {movement, map} = useStore();
  const [topNorth, setTopNorth] = useState(false);

  map.onRotation((rotation) => {
    if (Math.abs(rotation) < 0.02) {
      !topNorth && setTopNorth(true)
    } else {
      topNorth && setTopNorth(false)
    }
  })

	return  (
		<div className="float-buttons">
      <FloatButton.Group
        shape="square"
        className="zoom"
      >
        <FloatButton icon={<PlusOutlined/>} onClick={() => map.zoomIn()} />
        <FloatButton icon={<MinusOutlined />} onClick={() => map.zoomOut()}/>
      </FloatButton.Group>
      <FloatButton
        className="aim"
        icon={<AimIcon />}
        shape="square"
        onClick={() => movement.switchFollowing()}
        type={movement.isFollowing ? "primary" : "default"}
      />
      {movement.isFollowing
        ? <FloatButton
            className="compas"
            icon={<CompassOutlined />}
            shape="square"
            onClick={() => movement.switchCompas()}
            type={movement.isCompas ? "primary" : "default"}
          />
        : !topNorth && <FloatButton
            className="to-north"
            icon={<SendOutlined />}
            shape="square"
            onClick={() => map.rotate(0)}
            type="default"
          />
      }
      <FloatButton
        className="osm"
        icon={map.isOSM ? <OSMIcon /> : <S57Icon />}
        shape="square"
        onClick={() => map.toggleWorldLayer()}
        type={map.isOSM ? "primary" : "default"}
      />
		</div>
	)
}

export default observer(Buttons)
